import {
  SESSION_CLEAR,
  SESSION_LOADING,
  SESSION_SET_DATA,
} from "../actionNames";

const initialState = {
  authenticated: false,
  loading: true,
  role: null,
  userId: null,
  name: null,
};

let _accessToken = null;

export const getAccessToken = () => _accessToken;

export default (state = initialState, action) => {
  switch (action.type) {
    case SESSION_SET_DATA: {
      const token = action.data.token || _accessToken;
      _accessToken = token;
      return {
        authenticated: true,
        loading: false,
        user: {
          ...action.data.user,
        },
      };
    }
    case SESSION_CLEAR:
      _accessToken = null;
      return {
        authenticated: false,
        loading: false,
        user: null,
      };
    case SESSION_LOADING:
      return {
        ...state,
        loading: true,
      };
    default:
      return state;
  }
};
